<template>
  <div class="personnelList app-container">
    <template>
      <QueryForm
        ref="QueryForm"
        v-model="formInline"
        @onSearch="getData"
      />
      <DataTable
        ref="table"
        :list="taskList"
        :table-height="tableHeight"
        @downloadHandle="downloadHandle"
        @deleteHandle="deleteHandle"
        @detailHandle="detailHandle"
      />
      <BasePagination
        :total="total"
        :page-size="formInline.pageSize"
        :form="formInline"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
      <el-dialog
        title="详情"
        width="70%"
        :visible.sync="detailDialogVisible"
        :close-on-click-modal="false"
        append-to-body
      >
        <TaskDetail
          v-if="detailDialogVisible"
          :select-item="selectItem"
        />
      </el-dialog>
    </template>
  </div>
</template>

<script>
import QueryForm from './components/QueryForm.vue'
import DataTable from './components/Table.vue'
import { deleteTenementFileTask } from '@/api/user'
import mixins from '@/mixins/index'
import TaskDetail from '../task-detail/index.vue'
import { mapState } from 'vuex'

export default {
  components: { QueryForm, DataTable, TaskDetail },
  mixins: [mixins],
  props: {
    nodeKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      minusHeight: 400,
      formInline: {
        pageSize: 20,
        pageNumber: 1,
        time: '',
        taskType: '',
        fileName: '',
        operateType: '',
        taskStatus: ''
      },
      total: 0,
      addDialogVisible: false,
      formData: {},
      submitLoading: false,
      type: 1,
      detailDialogVisible: false
    }
  },
  computed: {
    ...mapState({
      projectItem: state => state.user.projectItem,
      taskList: state => state.user.taskList
    })
  },
  mounted() {

  },
  methods: {
    getData() {
      if (this.formInline.time) {
        this.formInline.startTime = this.formInline.time[0]
        this.formInline.endTime = this.formInline.time[1].split(' ')[0] + ' 23:59:59'
      } else {
        delete this.formInline.startTime
        delete this.formInline.endTime
      }
      const data = this.$store.dispatch('user/getTaskList', { businessId: this.projectItem.projectId, ...this.formInline })
      this.$refs.table.getInstance().bodyWrapper.scrollTop = 0
      data.then(res => {
        this.total = res.total
      })
    },
    handleSizeChange(e) {
      this.formInline.pageSize = e
      this.getData()
    },
    handleCurrentChange(e) {
      this.formInline.pageNumber = e
      this.getData()
    },
    downloadHandle(row, index) {
      var link = document.createElement('a')
      link.href = row.filePathUrl
      link.download = row.fileName
      link.click()
      // 释放内存
      window.URL.revokeObjectURL(link.href)
    },
    deleteHandle(row, index) {
      this.$confirm('此操作将永久删除任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '执行中...'
            try {
              await deleteTenementFileTask({ taskIdList: [row.taskId] })
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getData()
              done()
            } catch (error) {
              instance.confirmButtonText = '确定'
            }
            instance.confirmButtonLoading = false
          } else {
            done()
          }
        }
      })
    },
    detailHandle(row) {
      this.selectItem = Object.assign({}, row)
      this.detailDialogVisible = true
    }

  }
}
</script>

<style scoped>
.personnelList{
    background: #fff;
}
</style>

